import { ANALYZE_GAME } from "./Endpoints";

export const analyzeGame = async(game, userId) => {
    console.log("[API Request] - analyzeGame");
    const obj = {
        game: game,
        userId: userId
    };
    console.log("Game: ", obj);

    try {
        const response = await fetch(ANALYZE_GAME, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(obj)
        });

        if (!response.ok) {
            throw new Error("Network response was not ok.");
        }

        await response.json();
    } catch (error) {
        console.log("Error analyzing game: ", error);
        throw error;
    }
};
